import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import classNames from 'classnames';
import includes from 'lodash/includes';
import React, { Component } from 'react';
var css = {
  "buttonGroup": "rui-eKF4V",
  "selected": "rui-5WzCW"
};
var ButtonGroup = /*#__PURE__*/function (_Component) {
  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);
    return _callSuper(this, ButtonGroup, arguments);
  }
  _inherits(ButtonGroup, _Component);
  return _createClass(ButtonGroup, [{
    key: "onClickButton",
    value: function onClickButton(key) {
      this.props.onClick(key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.map(this.props.children, function (child, key) {
        if (/*#__PURE__*/React.isValidElement(child)) {
          return /*#__PURE__*/React.cloneElement(child, {
            id: key,
            onClick: function onClick() {
              return _this.onClickButton(key);
            },
            className: classNames(css.buttonGroup, includes(_this.props.selected, key) ? css.selected : '', child === null || child === void 0 ? void 0 : child.props.className)
          });
        }
        return null;
      }));
    }
  }]);
}(Component);
ButtonGroup.defaultProps = {
  onClick: function onClick() {},
  selected: [],
  children: []
};
export default ButtonGroup;